export default __webpack_public_path__ + "static/media/UI.354f4de1.webp";